import { Decimal } from 'decimal.js'

export * from './currencyFormatter'
export { btcPriceFormat, fiatCurrencyFormat } from './format'

export function getFiatCurrencyFormatOptions(
  price: number,
  skipLessThanHundredCheck?: boolean,
): Intl.NumberFormatOptions {
  if (price < 1) {
    return {
      maximumSignificantDigits: 4,
      minimumSignificantDigits: 4,
    }
  }
  if (price < 10) {
    return {
      maximumFractionDigits: 4,
      minimumFractionDigits: 4,
    }
  }

  // skipLessThanHundredCheck is true，skip this
  if (!skipLessThanHundredCheck && price < 100) {
    return {
      maximumFractionDigits: 3,
      minimumFractionDigits: 3,
    }
  }

  // 默认返回 2 位小数
  return {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }
}

export function getTokenQuantitiesFormatOptions(price: number): Intl.NumberFormatOptions {
  if (price < 1) {
    return {
      maximumSignificantDigits: 8,
      minimumSignificantDigits: 8,
    }
  }

  if (price < 100) {
    return {
      maximumFractionDigits: 4,
      minimumFractionDigits: 4,
    }
  }

  if (price > 1000000) {
    return {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }
  }

  return {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }
}

export const toFixed = (
  num: string | number,
  fractionDigits: number = 2,
  withoutZeroSign = true,
) => {
  const resultValue = new Decimal(num).toFixed(fractionDigits)
  if (Number(resultValue) === 0 && withoutZeroSign) {
    return (0).toFixed(fractionDigits)
  }
  return resultValue
}

export const formatUpToDecimals = (value: number, maxDigits = 2): string => {
  if (!Number.isFinite(value)) return '0'

  const factor = 10 ** maxDigits
  const rounded = Math.round(value * factor) / factor

  // Integer → no decimals
  if (Number.isInteger(rounded)) {
    return String(rounded)
  }

  // Keep up to maxDigits, trim trailing zeros
  return rounded.toFixed(maxDigits).replace(/\.?0+$/, '')
}

export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !isNaN(value)
